import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { InviteComponent } from './components/invite/invite.component';
import { UserJobComponent } from './components/job/userjob.component';
import { SelectUnitComponent } from './components/select-unit/selectUnit.component';
import { DsmComponent } from './components/dsm/dsm.component';
import { environment } from '../environments/environment';
import { NgModule } from '@angular/core';
import { NoContentComponent } from './components/noContent/noContent.component';
import { PaymentGuard } from './lib/services/paymentGuard';
import { AuthGuard } from './lib/services';
import { UnitInvitationComponent } from './components/unit-invitation/unit-invitation.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./auth-module/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard-module/dash.module').then(m => m.DashModule),
    canActivate: [AuthGuard, PaymentGuard],
  },
  {
    path: 'invite',
    component: InviteComponent,
    canActivate: [PaymentGuard],
  },
  {
    path: 'unit/:id/invite',
    component: UnitInvitationComponent,
  },
  {
    path: 'job/:id',
    component: UserJobComponent,
    canActivate: [PaymentGuard],
  },
  {
    path: 'select-unit',
    component: SelectUnitComponent,
  },
  {
    path: 'dsm',
    component: environment.production ? NoContentComponent : DsmComponent,
  },
  {
    path: '**',
    component: NoContentComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: Boolean(history.pushState) === false,
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
    }),
  ],
  declarations: [],
  exports: [RouterModule],
})
export class AppRoutingModule {}
